<div class="pme-container">


  <div class="display-utils-col display-utils-gt-sm-row display-utils-center" *ngIf="this.showErrorHero">
    <div class="pme-col display-utils-gt-sm-flex-50">
      <pme-hero *ngIf="this.showErrorHero" type="{{this.heroData.type}}" title="{{this.heroData.title}}">
        <p *ngFor="let content of this.heroData.contents" [innerHTML]="content"></p>
      </pme-hero>
    </div>
  </div>


  <div *ngIf="!this.showErrorHero && this.selectedPackage" class="pme-row display-utils-col-reverse display-utils-gt-sm-row display-utils-center display-utils-gap-0 display-utils-gt-sm-gap-60">

    <!-- Main -->
    <div class="pme-col display-utils-gt-sm-flex-50">
      <main>
        <h2 class="serasa-color-title display-utils-hide-lt-md">{{this.heroData.title}}</h2>
        <p class="display-utils-hide-lt-md" *ngFor="let content of this.heroData.contents" [innerHTML]="content"></p>
        <pme-payment-form [context]="'ACTIVATE_AUTO_RECHARGE'" 
          (formSubmitted)="this.onSubmit($event)"
          [buttonName]="this.buttonName" [hideConditions]="false" [paymentOptions]="this.paymentOptions"
          [creditCardData]="this.selfAttendanceData.creditCardData"
          [paymentChangeProduct]="this.selectedPackage.product"
          [termOfUse]="this.tdu"
          [maxLimitCreditCards]="maxLimitCreditCards"
          (deleteCreditCard)="handleDeleteCreditCard($event)"
          [creditCardData]="this.creditCardData"
          [creditCardsData]="this.creditCardsData">
        </pme-payment-form>
      </main>
    </div>



    <div class="pme-col display-utils-gt-sm-flex-50" *ngIf="this.context !== 'RETENTION'">
      <aside>
        <h2 class="serasa-color-title display-utils-only-lt-md">{{this.heroData.title}}</h2>
        <p class="display-utils-only-lt-md" *ngFor="let content of this.heroData.contents" [innerHTML]="content"></p>
        <pme-product-choice 
          [cardTitle]="'Meu Pacote'" 
          [productName]='this.selectedPackage.product.name'
          [totalValue]="this.selectedPackage.totalValue"
          [shopWindowLink]="this.shopWindowLink">
        </pme-product-choice>

      </aside>
    </div>

  </div>
</div>
